import PropTypes from 'prop-types'
import React from 'react'

import SearchLink from '../../../../shared/containers/searchLinkContainer'
import filterParamsConfig from '../../../../../common/constants/filterParamsConfig'
import CancelIcon from '../../../../shared/components/icons/cancel'

/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {Object} the locationParams
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
const FilterItem = ({ paramType, displayName, locationParams, index }) => {
  const Icon = filterParamsConfig[paramType].icon
  // only show icon for the first item
  return (
    <li key={index}>
      <div className="search-facet-actives__facet">
        <span className="search-facet-actives__icon">
          {index === 0 && Icon ? <Icon /> : null}
        </span>
        <span className="search-facet-actives__text">{displayName}</span>
        <SearchLink
          locationParams={locationParams}
          className="search-facet-actives__glyph-cancel"
        >
          <CancelIcon />
        </SearchLink>
      </div>
    </li>
  )
}

FilterItem.propTypes = {
  paramType: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  locationParams: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default FilterItem
